import { RefObject, useCallback } from 'react'
import { LightGalleryProps } from 'lightgallery/react'

import { FeaturePhotoPoint } from 'meta/photo/photoPoint'

import { GalleryProps } from 'client/components/Gallery/props'
import { useMapContext } from 'client/components/Map/context'

import { Objects } from 'utils/objects'

type Props = GalleryProps & {
  activePhotoPointRef: RefObject<FeaturePhotoPoint | undefined>
}

type Returned = NonNullable<LightGalleryProps['onBeforeSlide']>

export const useOnBeforeSlide = (props: Props): Returned => {
  const { photoPoints, activePhotoPointRef } = props

  const mapContext = useMapContext()

  return useCallback<Returned>(
    (detail) => {
      const { index } = detail
      const photo = photoPoints.at(index)
      activePhotoPointRef.current = photo

      setTimeout(() => {
        if (Objects.isNil(photo)) return
        mapContext.mapRef?.getMap().flyTo({
          center: photo.geometry.coordinates as [number, number],
          zoom: 14,
          duration: 800,
        })
      }, 100)
    },
    [activePhotoPointRef, mapContext.mapRef, photoPoints]
  )
}
